export default "__VITE_ASSET__BcuLJ1S$__"